import { render, staticRenderFns } from "./DkButton.vue?vue&type=template&id=6d5bf5e4&"
import script from "./DkButton.vue?vue&type=script&lang=js&"
export * from "./DkButton.vue?vue&type=script&lang=js&"
import style0 from "./DkButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports